export default {
    agentUIUrl: process.env.AGENT_UI_URL,
    adapterUrl: process.env.ADAPTER_URL,
    authUrl: process.env.AUTH_URL,
    envUrl: process.env.ENV_URL,
};
